
    import { Component, Vue, Watch } from "vue-property-decorator";
    import moment from "moment";
    import { SMSPreferences } from "@/models";
    import SaveMsgPopUp from "@/views/shared/SaveMsgPopUp.vue";
    import ConfirmMsgPopUp from "@/views/shared/ConfirmMsgPopUp.vue";
    import ErrorNotification from "@/views/shared/ErrorNotification.vue";
    import { namespace } from "vuex-class";
    import { useAppInsights } from '../../store/modules/AppInsights'
    import TrainingVideos from '../shared/TrainingVideos.vue';

    const profile = namespace("profile");

    @Component({ components: { SaveMsgPopUp, ConfirmMsgPopUp, ErrorNotification,TrainingVideos} })
    export default class SMSPref extends Vue {

        old_smsPrefData!: SMSPreferences;
        //isContentVisible: boolean = false;
        isMobileNoEnabled: boolean = false;
        isActivateButtonEnabled: boolean = false;
        isActivationCodeEnabled: boolean = false;
        isSMSNtfTypesDisabled: boolean = false;

        uoi_changed: boolean = false;
        mn_changed: boolean = false;
        ac_changed: boolean = false;
        acr_changed: boolean = false;
        amd_changed: boolean = false;
        acc_changed: boolean = false;
        sn_changed: boolean = false;
        sncp_changed: boolean = false;
        //cbt_changed: boolean = false;
        //cn_changed: boolean = false;

        isModalVisible: boolean = false;
        msgValue: string = '';
        classFlag: string = '';
        errorMsg: string = '';
        errorType: string = 'error';
        showErrorMsg: boolean = false;

        isConfirmModalVisible: boolean = false;
        confirmMsgValue: string = '';

        checkALLOption: boolean = false;

        timer: any = null;
        totalTime: number = 0;
        isTimerVisible: boolean = false;
        
        @profile.State
        public smsPrefData!: SMSPreferences;

        @profile.State 
        public profileData!: any;

        @profile.State
        isImpersonating!: boolean;
        
        @profile.State
        appInsightEventData!: any;

        mounted() {
            this.getSMSPrefData();           
        }

        async getSMSPrefData() {
            await this.$store.dispatch('profile/getSMSPrefDetails', this.profileData.username)
                .then((res: any) => {
                    if (this.smsPrefData != undefined) {
                        this.old_smsPrefData = JSON.parse(JSON.stringify(this.smsPrefData));

                        if (this.smsPrefData.validated == false && this.smsPrefData.isUserOptedIn == true) {
                            this.smsPrefData.activationCode = "";                            
                            if (this.smsPrefData.activationCodeExpiresUtc != null || this.smsPrefData.activationCodeExpiresUtc != undefined) {

                                let currentDate = moment(new Date().toISOString(), 'DD-MM-YYYY HH:mm:ss');
                                let expireDate = moment(this.smsPrefData.activationCodeExpiresUtc, 'DD-MM-YYYY HH:mm:ss');
                                if (currentDate < expireDate) {
                                    this.getTotalTime();
                                    this.isTimerVisible = true;
                                    this.startTimer();
                                    this.isActivationCodeEnabled = true;
                                    this.isMobileNoEnabled = false;

                                }
                                else {
                                    this.isMobileNoEnabled = true;
                                    this.isActivateButtonEnabled = true;
                                }
                                this.isActivationCodeEnabled = true;
                            }
                        }
                        else if (this.smsPrefData.validated == true && this.smsPrefData.isUserOptedIn == true) {
                            this.isMobileNoEnabled = true;
                        }
                        else {
                            this.isMobileNoEnabled = false;
                        }

                        if (this.smsPrefData.validated) {
                            this.isSMSNtfTypesDisabled = false;
                        }
                        else {
                            this.isSMSNtfTypesDisabled = true;
                        }

                        if (this.smsPrefData.assignmentCreated && this.smsPrefData.assignmentModified && this.smsPrefData.assignmentCanceled && this.smsPrefData.staffingNeed && this.smsPrefData.staffingNeedCriticalPay) {
                            this.checkALLOption = true;
                        }
                    }
                })
                .catch((err: any) => {
                    if (err) {
                        console.log(err);
                    }
                });
        }

        confirmedClicked() {
            this.isConfirmModalVisible = false;
            this.saveSMSPrefDetails();
        }

        validateSMSPrefDetails() {
            if ((this.smsPrefData.isUserOptedIn == false && this.uoi_changed == true)) {
                this.confirmMsgValue = "Do you really want to Opt-Out?";
                this.isConfirmModalVisible = true;
            }
            else {
                this.saveSMSPrefDetails();
            }
        }

        async saveSMSPrefDetails() {
            this.showErrorMsg = false;  
            await this.$store.dispatch('profile/saveSMSPrefDetails', { username: this.profileData.username, smsData: this.smsPrefData })
                .then((res: any) => {
                    this.resetControls();
                    this.msgValue = 'Your changes have been saved.';
                    this.classFlag = 'success';
                    this.showModal();
                })
                .catch((err: any) => {
                    if (err) {
                        console.log(err);
                    }
                });
        }

        async activateMobileNumber() {
             this.showErrorMsg = false;  
            if (this.validatePhoneNumber("Mobile")) {
                await this.$store.dispatch('profile/activateMobileNumber', { username: this.profileData.username, phoneNumber: this.smsPrefData.mobileNumber })
                    .then((res: any) => {
                        this.getTotalTime();
                        this.isTimerVisible = true;
                        this.startTimer();
                        this.isActivationCodeEnabled = true;
                        this.isMobileNoEnabled = false;
                        this.isActivateButtonEnabled = false;
                        this.isSMSNtfTypesDisabled = true;
                        this.old_smsPrefData.activationCodeExpiresUtc = this.smsPrefData.activationCodeExpiresUtc;
                        this.old_smsPrefData.validated = this.smsPrefData.validated;
                        this.old_smsPrefData.validatedDate = this.smsPrefData.validatedDate;
                        //this.isContentVisible = false;
                    })
                    .catch((err: any) => {
                        if (err) {                           
                                let parseResponse = err.request.responseText;                              
                                this.showErrorMsg = true;                            
                                this.errorMsg = (parseResponse != null || parseResponse != undefined) ? parseResponse : "An error has occurred. Please try again. If the error persists, contact Facility Scheduler support.";
                       }
                    });
            }
        }

        async reactivateMobileNumber() {
             this.showErrorMsg = false;  
            if (this.validatePhoneNumber("Mobile")) {
                await this.$store.dispatch('profile/reactivateMobileNumber', { username: this.profileData.username, phoneNumber: this.smsPrefData.mobileNumber })
                    .then((res: any) => {
                        this.getTotalTime();
                        this.isTimerVisible = true;
                        this.startTimer();
                        this.isActivationCodeEnabled = true;
                        this.isMobileNoEnabled = false;
                        this.isActivateButtonEnabled = false;
                        this.isSMSNtfTypesDisabled = true;
                        this.old_smsPrefData.activationCodeExpiresUtc = this.smsPrefData.activationCodeExpiresUtc;
                        this.old_smsPrefData.validated = this.smsPrefData.validated;
                        this.old_smsPrefData.validatedDate = this.smsPrefData.validatedDate;
                        //this.isContentVisible = false;
                    })
                    .catch((err: any) => {
                        if (err) {                           
                                let parseResponse = err.request.responseText;                              
                                this.showErrorMsg = true;                            
                                this.errorMsg = (parseResponse != null || parseResponse != undefined) ? parseResponse : "An error has occurred. Please try again. If the error persists, contact Facility Scheduler support.";
                       }
                    });
            }
        }

        async validateActivationCode() {
            if (this.smsPrefData.activationCode.length < 6) {
                this.msgValue = 'Activation code should be 6 digits';
                this.classFlag = 'error';
                this.showModal();
                return false;
            }
            else {
                await this.$store.dispatch('profile/validateActivationCode', { username: this.profileData.username, activationCode: this.smsPrefData.activationCode })
                    .then((res: any) => {
                        //this.isContentVisible = true;

                        if (this.smsPrefData.validated == true && this.smsPrefData.validatedDate !== null && (this.smsPrefData.validatedDate < this.smsPrefData.activationCodeExpiresUtc)) {
                            this.msgValue = 'Activation code validated.';
                            this.classFlag = 'success';
                            this.showModal();
                            this.isTimerVisible = false;
                            this.totalTime = 0;
                            this.isActivationCodeEnabled = false;
                            this.isMobileNoEnabled = true;
                            this.isActivateButtonEnabled = false;
                            this.isSMSNtfTypesDisabled = false;
                            this.old_smsPrefData.validated = this.smsPrefData.validated;
                            this.old_smsPrefData.validatedDate = this.smsPrefData.validatedDate;
                            this.old_smsPrefData.assignmentCreated = this.smsPrefData.assignmentCreated;
                            this.old_smsPrefData.assignmentModified = this.smsPrefData.assignmentModified;
                            this.old_smsPrefData.assignmentCanceled = this.smsPrefData.assignmentCanceled;
                            this.old_smsPrefData.staffingNeed = this.smsPrefData.staffingNeed;
                            this.old_smsPrefData.staffingNeedCriticalPay = this.smsPrefData.staffingNeedCriticalPay;
                        }
                        else {
                            this.msgValue = 'Please enter valid Activation Code';
                            this.classFlag = 'error';
                            this.showModal();
                            this.isSMSNtfTypesDisabled = true;
                        }
                    })
                    .catch((err: any) => {
                        if (err) {                           
                                let parseResponse = err.request.responseText;                              
                                this.showErrorMsg = true;                            
                                this.errorMsg = (parseResponse != null || parseResponse != undefined) ? parseResponse : "An error has occurred. Please try again. If the error persists, contact Facility Scheduler support.";
                       }
                    });
            }
        }

        onCAOChanges() {
            this.smsPrefData.assignmentCreated = this.checkALLOption;
            this.smsPrefData.assignmentModified = this.checkALLOption;
            this.smsPrefData.assignmentCanceled = this.checkALLOption;
            this.smsPrefData.staffingNeed = this.checkALLOption;
            this.smsPrefData.staffingNeedCriticalPay = this.checkALLOption;
        }

        validateNotificationTypes(flag) {
            let ACR_Val = this.smsPrefData.assignmentCreated;
            let AMD_Val = this.smsPrefData.assignmentModified;
            let ACC_Val = this.smsPrefData.assignmentCanceled;
            let SN_Val = this.smsPrefData.staffingNeed;
            let SNCP_Val = this.smsPrefData.staffingNeedCriticalPay;

            if (flag == 'assignmentCreated') {
                if (AMD_Val == true && ACC_Val == true && SN_Val == true && SNCP_Val == true) {
                    this.checkALLOption = ACR_Val;
                }
            }
            else if (flag == 'assignmentModified') {
                if (ACR_Val == true && ACC_Val == true && SN_Val == true && SNCP_Val == true) {
                    this.checkALLOption = AMD_Val;
                }
            }
            else if (flag == 'assignmentCanceled') {
                if (ACR_Val == true && AMD_Val == true && SN_Val == true && SNCP_Val == true) {
                    this.checkALLOption = ACC_Val;
                }
            }
            else if (flag == 'staffingNeed') {
                if (ACR_Val == true && AMD_Val == true && ACC_Val == true && SNCP_Val == true) {
                    this.checkALLOption = SN_Val;
                }
            }
            else if (flag == 'staffingNeedCriticalPay') {
                if (ACR_Val == true && AMD_Val == true && ACC_Val == true && SN_Val == true) {
                    this.checkALLOption = SNCP_Val;
                }
            }
        }

        validatePhoneNumber(flag) {
            var allowedFormat = /^\(?([0-9]{3})\)?[-]?([0-9]{3})[-]?([0-9]{4})$/;
            if (flag == "Mobile") {
                let mobileNumber: string = this.smsPrefData.mobileNumber;
                if ((mobileNumber == "") || (!mobileNumber.match(allowedFormat))) {
                    this.smsPrefData.activationCode = "";
                    this.isActivationCodeEnabled = false;
                    //this.isContentVisible = false;
                    this.msgValue = 'Please enter valid Mobile Phone Number like 123-456-7890';
                    this.classFlag = 'error';
                    this.showModal();
                    return false;
                }
            }
            else {
                let callNumber: string = this.smsPrefData.callNumber;
                if ((callNumber == "") || (!callNumber.match(allowedFormat))) {
                    this.msgValue = 'Please enter valid Call Number like 123-456-7890';
                    this.classFlag = 'error';
                    this.showModal();
                    return false;
                }
            }
            return true;
        }

        checkUSNumber(event) {
            let keyCode = event.keyCode ? event.keyCode : event.which;
            if (!((keyCode >= 48 && keyCode <= 57) || (keyCode == 45))) {
                event.preventDefault();
            }
        }

        onlyNumber(event) {
            let keyCode = event.keyCode ? event.keyCode : event.which;
            if (keyCode < 48 || keyCode > 57) {
                event.preventDefault();
            }
        }

        resetControls() {
            this.old_smsPrefData = JSON.parse(JSON.stringify(this.smsPrefData));
            this.uoi_changed = false;
            this.mn_changed = false;
            this.ac_changed = false;
            this.acr_changed = false;
            this.amd_changed = false;
            this.acc_changed = false;
            this.sn_changed = false;
            this.sncp_changed = false;
            this.showErrorMsg = false;  
            //this.cbt_changed = false;
            //this.cn_changed = false;
        }

        showModal() {
            this.isModalVisible = true;
        }

        closeModal() {
            this.isModalVisible = false;
        }

        getTotalTime() {
            if (this.smsPrefData.activationCodeExpiresUtc != undefined) {
                let currentDate = moment(new Date().toISOString(), 'DD-MM-YYYY HH:mm:ss');
                let expireDate = moment(this.smsPrefData.activationCodeExpiresUtc, 'DD-MM-YYYY HH:mm:ss');
                this.totalTime = expireDate.diff(currentDate, 'seconds');
                this.totalTime = (this.totalTime > 3600 ? 3600 : this.totalTime);
            }
        }

        startTimer() {
            this.timer = setInterval(() => this.countdown(), 1000);
        }

        stopTimer() {
            clearInterval(this.timer);
            this.timer = null;
        }

        padTime(time) {
            return (time < 10 ? '0' : '') + time;
        }

        countdown() {

            if (this.totalTime >= 1) {
                this.totalTime--;
            } else {
                this.totalTime = 0;
            }
        }

        ////computed
        get hours() {
            const hours = Math.floor(this.totalTime / 3600);
            return this.padTime(hours);
        }

        get minutes() {
            let currentMinutes = (this.totalTime - (Math.floor(this.totalTime / 3600) * 3600));
            const minutes = Math.floor(currentMinutes / 60);
            return this.padTime(minutes);
        }

        get seconds() {
            const seconds = this.totalTime % 60;
            return this.padTime(seconds);
        }

        get anyChangeHappened() {
             this.showErrorMsg = false;  
            let returnVal: boolean = false;
            if ((this.smsPrefData.isUserOptedIn == false && this.uoi_changed == true) ||
                (this.smsPrefData.isUserOptedIn == true && this.mn_changed == true && this.ac_changed == true && this.smsPrefData.validated == true) ||
                (this.smsPrefData.isUserOptedIn == true && this.mn_changed == false && this.ac_changed == true && this.smsPrefData.validated == true) ||
                ((this.smsPrefData.isUserOptedIn == true && this.mn_changed == true && this.ac_changed == true && this.smsPrefData.validated == true)
                    && (this.acr_changed == true || this.amd_changed == true || this.acc_changed == true
                        || this.sn_changed == true || this.sncp_changed == true)) ||
                ((this.smsPrefData.isUserOptedIn == true && this.mn_changed == false && this.ac_changed == true && this.smsPrefData.validated == true)
                    && (this.acr_changed == true || this.amd_changed == true || this.acc_changed == true
                        || this.sn_changed == true || this.sncp_changed == true)) ||
                ((this.smsPrefData.isUserOptedIn == true && this.mn_changed == false && this.ac_changed == false && this.smsPrefData.validated == true)
                    && (this.acr_changed == true || this.amd_changed == true || this.acc_changed == true
                        || this.sn_changed == true || this.sncp_changed == true))

            )//|| this.cbt_changed == true || this.cn_changed == true
            {
                returnVal = true;
            }
            return returnVal;
        }

        get totalTimerValue() {
            return this.totalTime;
        }

        @Watch("totalTimerValue")
        onttchanges(newValue: number) {
            if (newValue == 0 && this.isTimerVisible == true) {
                this.isMobileNoEnabled = true;
                this.isActivateButtonEnabled = true;
                //this.isActivationCodeEnabled = false;
                this.isTimerVisible = false;
                this.totalTime = 0;
                this.stopTimer();
            }
        }
        @Watch("smsPrefData.isUserOptedIn")
        onUOIChanges(newValue: boolean, oldValue: boolean) {

            if (this.old_smsPrefData != undefined) {
                this.uoi_changed = (this.old_smsPrefData.isUserOptedIn !== newValue ? true : false);
                if (newValue == true) {
                    this.isMobileNoEnabled = true;
                    this.smsPrefData.mobileNumber = this.old_smsPrefData.mobileNumber;
                    this.smsPrefData.activationCode = this.old_smsPrefData.activationCode;
                    this.smsPrefData.activationCodeExpiresUtc = this.old_smsPrefData.activationCodeExpiresUtc;
                    this.smsPrefData.validated = this.old_smsPrefData.validated;
                    this.smsPrefData.validatedDate = this.old_smsPrefData.validatedDate;
                    this.smsPrefData.assignmentCreated = this.old_smsPrefData.assignmentCreated;
                    this.smsPrefData.assignmentModified = this.old_smsPrefData.assignmentModified;
                    this.smsPrefData.assignmentCanceled = this.old_smsPrefData.assignmentCanceled;
                    this.smsPrefData.staffingNeed = this.old_smsPrefData.staffingNeed;
                    this.smsPrefData.staffingNeedCriticalPay = this.old_smsPrefData.staffingNeedCriticalPay;
                    if (this.smsPrefData.assignmentCreated && this.smsPrefData.assignmentModified && this.smsPrefData.assignmentCanceled && this.smsPrefData.staffingNeed && this.smsPrefData.staffingNeedCriticalPay) {
                        this.checkALLOption = true;
                    }
                    else {
                        this.checkALLOption = false;
                    }

                    if (this.smsPrefData.validated == false) {
                        this.smsPrefData.activationCode = "";
                        if (this.smsPrefData.activationCodeExpiresUtc != null || this.smsPrefData.activationCodeExpiresUtc != undefined) {
                            let currentDate = moment(new Date().toISOString(), 'DD-MM-YYYY HH:mm:ss');
                            let expireDate = moment(this.smsPrefData.activationCodeExpiresUtc, 'DD-MM-YYYY HH:mm:ss');
                            if (currentDate < expireDate) {
                                this.isTimerVisible = true;
                                this.isActivationCodeEnabled = true;
                                this.isMobileNoEnabled = false;
                            }
                            else {
                                this.isMobileNoEnabled = true;
                                this.isActivateButtonEnabled = true;
                            }
                        }
                        this.isSMSNtfTypesDisabled = true;
                    }
                    else {
                        this.isMobileNoEnabled = true;
                        this.isSMSNtfTypesDisabled = false;
                    }
                }
                else {
                    this.isMobileNoEnabled = false;
                    this.isActivationCodeEnabled = false;
                    this.isActivateButtonEnabled = false;
                    //this.isContentVisible = false;
                    this.smsPrefData.mobileNumber = "";
                    this.smsPrefData.validated = false;
                    this.smsPrefData.validatedDate = new Date(0);
                    // this.smsPrefData.callBeforeText = false;
                    //this.smsPrefData.callNumber = "";
                    this.smsPrefData.activationCode = "";
                    this.smsPrefData.activationCodeExpiresUtc = new Date(0);
                    this.checkALLOption = false;
                    this.smsPrefData.assignmentCreated = false;
                    this.smsPrefData.assignmentModified = false;
                    this.smsPrefData.assignmentCanceled = false;
                    this.smsPrefData.staffingNeed = false;
                    this.smsPrefData.staffingNeedCriticalPay = false;
                    this.isSMSNtfTypesDisabled = true;
                    if (this.isTimerVisible == true) {
                        this.isTimerVisible = false;
                    }
                }
            }
        }

        @Watch("smsPrefData.mobileNumber")
        onMNchanges(newValue: string) {
            if (this.old_smsPrefData != undefined && this.smsPrefData.isUserOptedIn == true) {
                this.mn_changed = (this.old_smsPrefData.mobileNumber !== newValue ? true : false);
                this.smsPrefData.validated = (this.old_smsPrefData.mobileNumber !== newValue ? false : this.old_smsPrefData.validated);
                //this.smsPrefData.validatedDate = (this.old_smsPrefData.mobileNumber !== newValue ? new Date(0) : this.old_smsPrefData.validatedDate);
                if (this.old_smsPrefData.mobileNumber !== newValue) {
                    this.smsPrefData.activationCode = "";
                    this.isActivationCodeEnabled = false;
                    this.isActivateButtonEnabled = true;
                }
                else {

                    if (this.smsPrefData.validated == false) {
                        this.smsPrefData.activationCode = "";

                        if (this.smsPrefData.activationCodeExpiresUtc != null || this.smsPrefData.activationCodeExpiresUtc != undefined) {
                            let currentDate = moment(new Date().toISOString(), 'DD-MM-YYYY HH:mm:ss');
                            let expireDate = moment(this.smsPrefData.activationCodeExpiresUtc, 'DD-MM-YYYY HH:mm:ss');
                            if (currentDate < expireDate) {
                                this.isActivationCodeEnabled = true;
                                this.isMobileNoEnabled = false;
                            }
                            else {
                                this.isMobileNoEnabled = true;
                                this.isActivateButtonEnabled = true;
                            }
                        }
                    }
                    else {
                        this.isActivateButtonEnabled = false;
                        this.smsPrefData.activationCode = this.old_smsPrefData.activationCode;
                    }
                }
            }
        }

        @Watch("smsPrefData.activationCode")
        onATCchanges(newValue: string) {

            if (this.old_smsPrefData != undefined) {
                this.ac_changed = (this.old_smsPrefData.activationCode !== newValue ? true : false);
            }
        }

        @Watch("smsPrefData.assignmentCreated")
        onACRChanges(newValue: boolean, oldValue: boolean) {
            this.validateNotificationTypes("assignmentCreated");
            if (this.old_smsPrefData != undefined) {
                this.acr_changed = (this.old_smsPrefData.assignmentCreated !== newValue ? true : false);
            }
        }

        @Watch("smsPrefData.assignmentModified")
        onAMChanges(newValue: boolean, oldValue: boolean) {
            this.validateNotificationTypes("assignmentModified");
            if (this.old_smsPrefData != undefined) {
                this.amd_changed = (this.old_smsPrefData.assignmentModified !== newValue ? true : false);
            }
        }

        @Watch("smsPrefData.assignmentCanceled")
        onACCChanges(newValue: boolean, oldValue: boolean) {
            this.validateNotificationTypes("assignmentCanceled");
            if (this.old_smsPrefData != undefined) {
                this.acc_changed = (this.old_smsPrefData.assignmentCanceled !== newValue ? true : false);
            }
        }

        @Watch("smsPrefData.staffingNeed")
        onSNChanges(newValue: boolean, oldValue: boolean) {
            this.validateNotificationTypes("staffingNeed");
            if (this.old_smsPrefData != undefined) {
                this.sn_changed = (this.old_smsPrefData.staffingNeed !== newValue ? true : false);
            }
        }

        @Watch("smsPrefData.staffingNeedCriticalPay")
        onSNCPChanges(newValue: boolean, oldValue: boolean) {
            this.validateNotificationTypes("staffingNeedCriticalPay");
            if (this.old_smsPrefData != undefined) {
                this.sncp_changed = (this.old_smsPrefData.staffingNeedCriticalPay !== newValue ? true : false);
            }
        }

        ///-- All code which is related to Call Number and Call before text checkbox is commented for now-- if it comes in future then it will be reused--///
        //@Watch("smsPrefData.callBeforeText")
        //onCBTChanges(newValue: boolean, oldValue: boolean) {
        //    if (newValue == true) {
        //        this.smsPrefData.callNumber = (this.smsPrefData.callNumber == "" ? this.smsPrefData.mobileNumber : this.smsPrefData.callNumber);
        //    }
        //    else {
        //        this.smsPrefData.callNumber = "";
        //    }

        //    if (this.old_smsPrefData != undefined) {
        //        this.cbt_changed = (this.old_smsPrefData.callBeforeText !== newValue ? true : false);
        //    }
        //}

        //@Watch("smsPrefData.callNumber")
        //onCNChanges(newValue: string, oldValue: string) {

        //    if (this.old_smsPrefData != undefined) {
        //        this.cn_changed = (this.old_smsPrefData.callNumber !== newValue ? true : false);
        //    }
        //}
    }
